import { useAuth } from "../../../usercontext";
import GlobalStudentLesson from "../../pages/common/globalstudentlessonforgrade";
import S12TopMenu from "../../student12/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import GlobalStudentLesson2 from "../../pages/common/globalstudentlesson2";
import GlobalStudentGpaRigorSummary from "../../pages/common/globalstudentgparigorsummary";
import GlobalStudentAverageGpaSummary from "../../pages/common/GlobalStudentAverageGpaSummary";
import GlobalStudentCalculatedGpaSummary from "../../pages/common/GlobalStudentCalculatedGpaSummary";
import GlobalStudentApScoreSummary from "../../pages/common/GlobalStudentApScoreSummary";
import GlobalStudentCourseLessonReport from "../../pages/common/globalstudentcourselessonreport";
import GlobalStudentCourseLessonAverageGpaReport from "../../pages/common/GlobalStudentCourseLessonAverageGpaReport";
import GlobalStudentCourseLessonLevelReport from "../../pages/common/globalstudentcourselessonlevelreport";
import GlobalStudentCourseLessonGradeYearReport from "../../pages/common/globalstudentcourselessongradeyearreport";
import GlobalStudentCourseLessonCalculatedGpaReport from "../../pages/common/GlobalStudentCourseLessonCalculatedGpaReport";

export default function StudentCoursesReport() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent911 = profile?.role === "Student911";
  return (
    <>
      {/* {!isStudent911 && <S12TopMenu slug={slug} activeMenu="CoursesReport" />} */}
      {/* {isStudent911 && <S911TopMenu slug={slug} activeMenu="CoursesReport" />} */}
      <GlobalStudentGpaRigorSummary studentId={slug} isStudent={true} />
      <GlobalStudentAverageGpaSummary studentId={slug} isStudent={true} />
      <GlobalStudentCalculatedGpaSummary studentId={slug} isStudent={true} />
      <GlobalStudentApScoreSummary studentId={slug} isStudent={true} />
      <GlobalStudentCourseLessonReport studentId={slug} isStudent={true} />
      <GlobalStudentCourseLessonAverageGpaReport studentId={slug} isStudent={true} />
      <GlobalStudentCourseLessonCalculatedGpaReport studentId={slug} isStudent={true} />
      <GlobalStudentCourseLessonLevelReport studentId={slug} isStudent={true} />
      <GlobalStudentCourseLessonGradeYearReport studentId={slug} isStudent={true} />
    </>
  );
}
